import MuiTableCell from './MuiTableCell'
import MuiSvgIcon from './MuiSvgIcon'
import MuiIcon from './MuiIcon'
import MuiTableRow from './MuiTableRow'

export default { MuiTableCell, MuiSvgIcon, MuiIcon, MuiTableRow }